import {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import SMSCode from '../../../../../component/SMSCode/SMSCode';
import {TOrderChangePhonePayload} from '../../../../../redux/crm/crm.type';
import * as sharedCss from '../../OrderChangePhonePopup.css';
import * as css from './CodeFormStep.css';
import OrderMetaRow from '../OrderMetaRow/OrderMetaRow';
import {parsePhoneForOrder, PhoneFormValues} from '../../utils';

type Props = {
    orderData: TOrderChangePhonePayload;
    newPhone: PhoneFormValues;
    sendXHR: string;
    onVerifyCode: (code: string) => Promise<void>;
    onSendCode: (phoneInputValues: PhoneFormValues) => Promise<void>;
};

export default function CodeFormStep({
    orderData,
    newPhone,
    sendXHR,
    onVerifyCode,
    onSendCode,
}: Props) {
    const {t} = useTranslation('layout');
    const [smsCodeMountKey, setSmsCodeMountKey] = useState(0);

    const handleSendAgain = useCallback(async () => {
        setSmsCodeMountKey((k) => k + 1);
        await onSendCode(newPhone);
    }, [newPhone, onSendCode]);

    const sendLoading = sendXHR === 'LOADING';

    return (
        <sharedCss.card>
            <sharedCss.dealTitle>{t('orderChangePhoneDealLabel', {orderId: orderData.oid})}</sharedCss.dealTitle>
            <OrderMetaRow orderData={orderData} />
            <sharedCss.divider />
            <css.sectionTitle>{t('orderChangePhoneEnterCodeHeading')}</css.sectionTitle>
            <SMSCode
                key={smsCodeMountKey}
                amount={6}
                onUpdate={onVerifyCode}
                sendAgainClick={handleSendAgain}
                address={parsePhoneForOrder(newPhone.phone, newPhone.country)}
                text={`${t('orderChangePhoneCodeHint')} `}
                disabled={sendLoading}
            />
        </sharedCss.card>
    );
}
